<div class="header" [style.color]="color()">
  <label class="label flex-grow flex items-center" [ngStyle]="labelStyles()">
    @if (icon(); as ico) {
      <mat-icon [svgIcon]="ico" [ngStyle]="iconStyles()" />
    }
    <span>
      <span [ngStyle]="textStyles()"><ng-content /></span>
    </span>
  </label>
</div>
